import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {QuestionTypeFactoryService} from 'shared/questions/services/question-type-factory.service';
import {QuestionsDetailsRoutingModule} from './questions-details-routing.module';
import {QuestionsDetailsComponent} from './questions-details.component';
import {QuestionsDetailsHttpRepository} from './repositories/questions-details.repository.http';
import {QuestionsDetailsService} from './services/questions-details.service';
import {TypeButtonListModule} from './type-components/type-button-list/type-button-list.module';
import {TypeEnergylevelModule} from './type-components/type-energylevel/type-energylevel.module';
import {TypeMultiSliderModule} from './type-components/type-multi-slider/type-multi-slider.module';
import {TypePerformancelevelModule} from './type-components/type-performancelevel/type-performancelevel.module';
import {TypeRatingModule} from './type-components/type-rating/type-rating.module';
import {TypeSliderModule} from './type-components/type-slider/type-slider.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    QuestionsDetailsRoutingModule,
    LanguageDropdownModule,
    TypeButtonListModule,
    TypeSliderModule,
    TypeRatingModule,
    TypeEnergylevelModule,
    TypePerformancelevelModule,
    TypeMultiSliderModule,
  ],
  declarations: [
    QuestionsDetailsComponent,
  ],
  providers: [
    QuestionTypeFactoryService,
    QuestionsDetailsService,
    {
      provide: 'IQuestionsDetailsRepository',
      useClass: QuestionsDetailsHttpRepository,
    },
  ],
})
export class QuestionsDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/questions-details.module.ts